import { styled } from '@mui/material';

export const LogoLink = styled('a')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const NimbleLogoContainer = styled('img')(() => ({
  display: 'flex',
  width: '132.656px',
  height: '36.129px',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
}));

export const NimbleMobileLogoContainer = styled('img')(() => ({
  display: 'flex',
  width: '36.129px',
  height: '36.129px',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
}));

export const StateDOELogoContainer = styled('img')(() => ({
  display: 'flex',
  maxHeight: '46px',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StateDOEMobileLogoContainer = styled('img')(() => ({
  maxHeight: '46px',
  maxWidth: '126px',
}));
